import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import OrderAmountDetailDataGrid from 'components/reports/orders/OrderAmountDetailDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import {
  convertQueryParamsIntoObject,
  isoFormat,
  convertObjectIntoQueryParams,
} from 'constant/Helpers';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
// api
import OrdersReportService from 'services/reportsService/OrdersReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const OrderAmountDetailReportPage = () => {
  const [orderAmountDetailData, setOrderAmountDetailData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: isoFormat(new Date()),
    toDate: isoFormat(new Date()),
    type: -1,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await OrdersReportService.getOrderAmountDetailReport(params);
      setOrderAmountDetailData(res.data);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Order Amount Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
    } else {
      fetchData(inputValues);
    }
  }, []);

  const handleSubmit = async () => {
    const queryString = convertObjectIntoQueryParams(inputValues);

    navigate({
      pathname: '/report/OrderAmountDetailReport',
      search: queryString,
    });
    fetchData(inputValues);
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        orderStatus
        isoDate
        title="Order Amount Details"
      />
      <OrderAmountDetailDataGrid data={orderAmountDetailData} params={inputValues} />
    </div>
  );
};

export default OrderAmountDetailReportPage;
